import { styled } from "simplydo/react/styled";
import { useTheme } from "simplydo/react/theme";

import util from "utils/utils";

import { UserChip } from "components/lib/Chips";
import type { ChipUser } from "components/lib/Chips/types";

const Bar = styled.div<{ $gradient: string }>`
  height: 60px;
  padding: 15px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-image: ${({ $gradient }) => $gradient};
  top: 50px;
  width: 100%;
  z-index: 8;
  position: fixed;
`;

type UserStatusBarProps = { profileUser: ChipUser };

const UserStatusBar = ({ profileUser }: UserStatusBarProps) => {
  const theme = useTheme();
  const gradient = `linear-gradient(to bottom right, ${theme.secondaryColour}, ${util.adjustColour(theme.secondaryColour, 0.5)})`;

  if (!profileUser || !profileUser.profile) return null;
  return (
    <Bar $gradient={gradient}>
      <UserChip user={profileUser} inverted />
    </Bar>
  );
};

export default UserStatusBar;
